import { GET_LOGGED_USER } from '@/graphql/user.graphql'
import { apolloClient } from '@/apollo'
import { logout } from '@/http'

const state = {
  user: null,
  loading: true,
}

const getters = {
  isAuthenticated: state => !!state.user,
  user: state => state.user,
}

const mutations = {
  setUser(state, user) {
    state.user = user
    state.loading = false
  },
  setLoading(state, loading) {
    state.loading = loading
  },
}

const actions = {
  async fetchUser({ commit }) {
    commit('setLoading', true)
    try {
      const { data } = await apolloClient.query({
        query: GET_LOGGED_USER,
        fetchPolicy: 'network-only',
      })
      commit('setUser', data.me)
    } catch (error) {
      // If there's an error (e.g., no token), it means the user is not logged in.
      commit('setUser', null)
    }
  },
  async login({ dispatch }, { token }) {
    if (token) {
      localStorage.setItem('token', token)
    }
    await dispatch('fetchUser')
  },
  async logout({ commit }) {
    await logout()
    commit('setUser', null)
    // You might want to redirect the user to the login page here.
    // For now, we'll just clear the state.
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
